<div class="flex flex-center">
  <button type="button" mat-button (click)="input.click()">
    <mat-icon>upload</mat-icon>
    {{ label() }}
  </button>

  <span>{{ value()?.name ?? 'Keine Datei ausgewählt' }}</span>
</div>

<input type="file" style="display: none" [accept]="accept()" (change)="setFile(input.files?.item(0) ?? undefined)" #input />
